<form [formGroup]='consentMovers' (ngSubmit)='onSubmit()' id='{{formGroupName}}'>

	<div *ngIf='!this.formService.fccLoading' class='step-title' i18n>Your <span class='color-blue'>Top 5</span> moving companies</div>

	<div *ngIf='this.formService.fccLoading' class='loader'>
		<div class='loader-spinner'></div>
	</div>

	<app-consent-movers-list
		*ngIf='!this.formService.fccLoading'
		[movers]="allMovers"
		[displayedIndices]="displayedIndices"
		[form]="consentMovers"
		[viewMode]="'default'"
		(openModal)="openModal()">
	</app-consent-movers-list>

	<!-- Validation error message -->
	<div *ngIf="consentMovers.touched && consentMovers.errors?.['noMoverSelected']" class="error-message" i18n>
		Please select at least one moving company to continue
	</div>

	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backMainForm()'>
				<mat-icon svgIcon='icons:chevron-left'></mat-icon>
				<ng-container i18n='@@buttonBack'>Back</ng-container>
			</button>
			<button class='submit'
			        type='submit'><ng-container i18n='@@buttonContinue'>Continue</ng-container>
				<mat-icon svgIcon='icons:chevron-right'></mat-icon>
			</button>
		</div>
	</div>

</form>